<template>
    <div class="row">
        <div class="col-md-12">
            <div class="panel-group" id="accordion">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" data-parent="#accordion" href="#collapse1">
                                Employee
                            </a>
                        </h4>
                    </div>
                    <div id="collapse1" class="panel-collapse collapse in">
                        <div class="panel-body">
                            <div v-if="userDocs != null" class="col-md-12" id="Employee">
                                <div v-for="e in userDocs.Employee">
                                    <div class="col-md-4 docTitle">{{ e }}</div><div class="col-md-2 createDoc"><a v-bind:href="'/ElectronicForms/' + e" target="_blank">Create New &nbsp;<span class="glyphicon glyphicon-plus-sign"></span></a></div><br><hr>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" data-parent="#accordion" href="#collapse2">
                                Finance
                            </a>
                        </h4>
                    </div>
                    <div id="collapse2" class="panel-collapse collapse">
                        <div class="panel-body">
                            <div v-if="userDocs != null" class="col-md-12" id="Finance">
                                <div v-for="f in FinanceDocs">
                                    <div class="col-md-4 docTitle">{{ f }}</div>
                                    <div v-if="f=='FIN - Financial Signature Approval - FSA (UFW)'" class="col-md-2 createDoc"><a v-bind:href="'/redirect/to/fsa'" target="_blank">Create New &nbsp;<span class="glyphicon glyphicon-plus-sign"></span></a></div>
                                    <div v-else class="col-md-2 createDoc"><a v-bind:href="'/ElectronicForms/' + f" target="_blank">Create New &nbsp;<span class="glyphicon glyphicon-plus-sign"></span></a></div>
                                    <br><hr>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" data-parent="#accordion" href="#collapse3">
                                Human Resources
                            </a>
                        </h4>
                    </div>
                    <div id="collapse3" class="panel-collapse collapse">
                        <div class="panel-body">
                            <div v-if="userDocs != null" class="col-md-12" id="Human Resources">
                                <div v-for="hr in HumanResourcesDocs">
                                    <div class="col-md-4 docTitle">{{ hr }}</div><div class="col-md-2 createDoc"><a v-bind:href="'/ElectronicForms/' + hr" target="_blank">Create New &nbsp;<span class="glyphicon glyphicon-plus-sign"></span></a></div><br><hr>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4 class="panel-title">
                            <a data-toggle="collapse" data-parent="#accordion" href="#collapse4">
                                University
                            </a>
                        </h4>
                    </div>
                    <div id="collapse4" class="panel-collapse collapse">
                        <div class="panel-body">
                            <div class="col-md-12" id="University">
                                <div class="col-md-4 docTitle">UAL Farm Use Log</div><div class="col-md-2 createDoc"><a href="/ElectronicForms/UAL_ActivityLog" target="_blank">Create New &nbsp;<span class="glyphicon glyphicon-plus-sign"></span></a></div><br><hr>
                                <div v-if="userDocs != null">
                                    <div v-for="cc in UniversityDocs">
                                        <div class="col-md-4 docTitle">{{ cc }}</div><div class="col-md-2 createDoc"><a v-bind:href="'/ElectronicForms/' + cc" target="_blank">Create New &nbsp;<span class="glyphicon glyphicon-plus-sign"></span></a></div><br><hr>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

    
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'app',
    props: {
        // 'userDocs': Object,
        // 'userID': String
        },
    data () {
        return {
            message: 'Welcome to Your Vue.js App abc, yes, it works, hot load.',
            userID: null,
            sessionID: null,
            userDocs: null,
        }
    },
    created () {
        var self = this;
        // get user id
        axios.post("/Home/GetUserID")
            .then(function(response){
            // console.log(response)
            self.userID = response.data

            axios.post("/Home/GetSessionID")
                .then(function(response){
                // console.log(response)
                self.sessionID = response.data
                if (self.sessionID != null && self.sessionID != "") {
                    axios.post("/Home/GatherDocs", { userID: self.userID, OBSessionID: self.sessionID })
                        .then(function(response){
                        // console.log(response)
                        self.userDocs = response.data //.filter(doc => doc === "visitorparking")
                    });
                }
            });
        });
    },

    mounted () {
    
    },

    computed: {
        FinanceDocs() {
            let result = [];
            if ("undefined" !== typeof(this.userDocs["Finance"])) {
                result = this.userDocs["Finance"].filter(x => x === "FIN - Financial Signature Approval - FSA (UFW)");
            }
            return result;
        },
        
        UniversityDocs() {
            let result = [];
            if ("undefined" !== typeof (this.userDocs["University"])) {
                result = this.userDocs["University"].filter(x => x === "Visitor Parking Request" || x === "IT Purchase Review");
            }
            return result;
        },
        HumanResourcesDocs() {
            let result = [];
            if ("undefined" != typeof (this.userDocs["Human Resources"])) {
                //result = this.userDocs["Human Resources"].filter(x => x === "Worker Injury Form");
            }
            return result;
        },
    },

    methods: {

    }
    
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ClientApp/ElectronicForms/App.vue